import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Typography,
} from "antd";
import dayjs from "dayjs";

import "./AddNewLoCCategoryModal.css";
import { ReactComponent as MobCreditLogo } from "../../../../assets/icons/mobPartner.svg";
import {
  showErrorToast,
  showSuccessToast,
} from "../../../../NotificationToast/NotificationToast";

const { TextArea } = Input;

const AddNewLoCCategoryModal = ({
  createCategoryApi,
  updateCategoryApi,
  editCategoryData,
  addCategoryModal,
  setAddCategoryModal,
  refreshList,
  onClose,
}) => {
  const { Text } = Typography;
  const [isFormValid, setIsFormValid] = useState(false);
  const [formData, setFormData] = useState({});
  const isEditMode = !!editCategoryData;

  const validateForm = () => {
    const requiredFields = [
      "category",
      "start_order_date",
      "line_of_credit_interest",
      "mob_partner_fees",
      "interest_after",
    ];

    const isValid = requiredFields.every((field) => !!formData[field]);
    setIsFormValid(isValid);
  };

  const handleSaveCategory = async () => {
    const payload = {
      category: formData?.category,
      interest_after: formData?.interest_after,
      start_order_date: formData?.start_order_date?.format("YYYY-MM-DD"),
      line_of_credit_interest: formData?.line_of_credit_interest,
      terms_and_conditions: formData?.terms_and_conditions,
      mob_partner_fees: formData?.mob_partner_fees,
      category_name: formData?.category_name,
    };

    let response;
    if (isEditMode) {
      response = await updateCategoryApi({
        id: editCategoryData?.id,
        ...payload,
      });
    } else {
      response = await createCategoryApi(payload);
    }

    if (response?.error?.data?.status === false) {
      showErrorToast(response?.error?.data?.message);
    } else {
      showSuccessToast(response?.data?.message);
      handleCancel();
      refreshList();
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleCancel = () => {
    setAddCategoryModal(false);
    setFormData({});
    if (onClose) onClose();
  };

  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  useEffect(() => {
    if (isEditMode && editCategoryData) {
      setFormData({
        category: editCategoryData?.category || "",
          category_name: editCategoryData?.category_name || "",
        start_order_date: editCategoryData?.start_order_date
          ? dayjs(editCategoryData?.start_order_date)
          : null,
        line_of_credit_interest:
          editCategoryData?.line_of_credit_interest || "",
        terms_and_conditions: editCategoryData?.terms_and_conditions || "",
        mob_partner_fees: editCategoryData?.mob_partner_fees || "",
        interest_after: editCategoryData?.interest_after || "",
      });
    }
  }, [isEditMode, editCategoryData]);

  return (
    <>
      <Modal
        title={isEditMode ? "Edit Segment" : "Add New Segment"}
        open={addCategoryModal}
        onCancel={handleCancel}
        onOk={handleCancel}
        footer={[
          <Col
            key="footer"
            style={{
              display: "flex",
              justifyContent: "center",
              padding: "28px",
              borderTop: "1px solid #dedede",
            }}
          >
            <Button
              onClick={handleCancel}
              style={{
                height: "48px",
                fontWeight: 500,
                fontSize: "14px",
                maxWidth: "120px",
                width: "100%",
              }}
            >
              CANCEL
            </Button>
            <Button
              style={{
                height: "48px",
                fontWeight: 500,
                fontSize: "14px",
                border: "none",
                color: "white",
                backgroundColor: "#0354a3",
              }}
              onClick={handleSaveCategory}
              disabled={!isFormValid}
            >
              {isEditMode ? "UPDATE SEGMENT" : "ADD SEGMENT"}
            </Button>
          </Col>,
        ]}
      >
        <Form
          name="delivery_address"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          style={{
            height: "360px",
            width: "100%",
            overflow: "auto",
          }}
          autoComplete="off"
        >
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "2px 18px 18px 18px",
              gap: 12,
            }}
          >
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Segment <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0, flex: 1 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="category"
                  value={formData?.category}
                  onChange={(e) =>
                    handleInputChange("category", e.target.value)
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  <Col>
                    Segment name <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0, flex: 1 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="category_name"
                  value={formData?.category_name}
                  onChange={(e) =>
                    handleInputChange("category_name", e.target.value)
                  }
                />
              </Form.Item>
            </Col>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Start order date{" "}
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0, flex: 1 }}
              >
                <DatePicker
                  style={{ height: 45, width: "100%" }}
                  format="DD-MMM-YYYY"
                  placeholder="Select date"
                  value={formData?.start_order_date}
                  onChange={(date) =>
                    handleInputChange("start_order_date", date)
                  }
                />
              </Form.Item>
              <Form.Item
                label={
                  <Col>
                    Line of credit interest/ year{" "}
                    <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0, flex: 1 }}
              >
                <Input
                  style={{ height: 45 }}
                  name="line_of_credit_interest"
                  maxLength={10}
                  onKeyDown={(e) => {
                    if (
                      (e.key < "0" || e.key > "9") &&
                      e.key !== "Backspace" &&
                      e.key !== "ArrowLeft" &&
                      e.key !== "ArrowRight" &&
                      e.key !== "Tab" &&
                      e.key !== "."
                    ) {
                      e.preventDefault();
                    }
                  }}
                  value={formData?.line_of_credit_interest}
                  onChange={(e) =>
                    handleInputChange("line_of_credit_interest", e.target.value)
                  }
                />
              </Form.Item>
            </Col>
            <Col style={{ display: "flex", gap: "1rem" }}>
              <Form.Item
                label={
                  <Col>
                    Subvention days <Text style={{ color: "#FF0000" }}> *</Text>
                  </Col>
                }
                style={{ margin: 0, flex: 1 }}
              >
                <Select
                  style={{ height: 45, width: "100%" }}
                  dropdownMatchSelectWidth={false}
                  dropdownStyle={{ minWidth: "auto", maxWidth: "230px" }}
                  placeholder="Select days"
                  value={formData?.interest_after}
                  options={[0, 7, 14, 21, 30, 45, 60].map((d) => ({
                    value: d,
                    label: `${d} days`,
                  }))}
                  onChange={(value) =>
                    handleInputChange("interest_after", value)
                  }
                />
              </Form.Item>
            </Col>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 18px 18px 18px",
              gap: 12,
            }}
          >
            <Form.Item
              label={<Col>Terms and conditions</Col>}
              style={{ margin: 0 }}
            >
              <TextArea
                value={formData?.terms_and_conditions}
                name="terms_and_conditions"
                rows={4}
                placeholder="Enter terms and conditions"
                onChange={(e) =>
                  handleInputChange("terms_and_conditions", e.target.value)
                }
              />
            </Form.Item>
          </Col>
          <Col
            span={24}
            style={{
              justifyContent: "space-between",
              margin: "12px",
              display: "flex",
              gap: "1rem",
              alignItems: "center",
              padding: "18px 18px 18px 18px",
              borderRadius: "12px",
              backgroundColor: "#ebf7ef",
            }}
          >
            <Col>
              <MobCreditLogo />
              <br />
              <Text style={{ fontWeight: "500" }}>Line of credit fees</Text>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #d9d9d9",
                borderRadius: "8px",
                overflow: "hidden",
                height: "45px",
              }}
            >
              <Input
                style={{
                  height: "100%",
                  width: "120px",
                  border: "none",
                  boxShadow: "none",
                }}
                name="mob_partner_fees"
                maxLength={10}
                onKeyDown={(e) => {
                  if (
                    (e.key < "0" || e.key > "9") &&
                    e.key !== "Backspace" &&
                    e.key !== "ArrowLeft" &&
                    e.key !== "ArrowRight" &&
                    e.key !== "Tab" &&
                    e.key !== "."
                  ) {
                    e.preventDefault();
                  }
                }}
                value={formData?.mob_partner_fees}
                onChange={(e) =>
                  handleInputChange("mob_partner_fees", e.target.value)
                }
              />
              <div
                style={{
                  padding: "0 12px",

                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  borderLeft: "0px",
                }}
              >
                <Text>per transaction</Text>
              </div>
            </Col>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
              padding: "10px 18px 18px 18px",
            }}
          >
            <Text style={{ fontWeight: "500" }}>Visible to customer</Text>
            <Col
              style={{
                padding: "18px 18px 18px 18px",
                borderRadius: "12px",
                backgroundColor: "#fdf8d7",
              }}
            >
              <p style={{ fontWeight: "500" }}>
                Zero% interest for {formData?.interest_after || 0} days
              </p>
              <p>
                {formData?.line_of_credit_interest || 0}% per year after{" "}
                {formData?.interest_after || 0} days of transaction confirmation
              </p>
              {formData?.terms_and_conditions && (
                <p>{formData?.terms_and_conditions}</p>
              )}
            </Col>
          </Col>
        </Form>
      </Modal>
    </>
  );
};

export default React.memo(AddNewLoCCategoryModal);
